import {useEffect, useState} from 'react'
import { setTitlePage, isOnlyNumbers } from '../../Functions'
import { accountMedicalTeam } from "../../Api";
import PaginationComponent from '../../components/PaginationComponent/PaginationComponent';
import Search from './Search';
import Table from './Table';
import { Modal as ModalBootstrap } from "bootstrap";
import Modal from '../../components/Modal/Modal'
import QueryDetail from './QueryDetail';
import Axios from 'axios';
import { useAuth } from '../../../app/modules/auth'
import * as XLSX from 'xlsx';
import { AlertDialog } from '../../components/Dialog/Dialog';
const AccountMedicalTeam = () => {
  const [showAlertError, setShowAlertError] = useState(false);
  const [messageAlertError, setMessageAlertError] = useState('No se encontraron resultados para tu búsqueda.');
  const { auth } = useAuth();
  const [state, setState] = useState({
    data: [],
    pageCount: 0,
    pageIndex: 0,
    pageSize: 0,
    pages: 0,
    loading: false,
  });
  const [filters, setFilters] = useState({
    rol: '',
    paciente: '',
  });
  const [detail, setDetail] = useState({});

  useEffect(() => {
    setTitlePage('Equipo Médico');
  }, [])

  const onChange = (e:any) => {
    const { name, value } = e.target;
    setFilters({...filters, [name]: value});
  }

  const openModalDetail = (row:any) => {
    setDetail(row);
    const idModal = document.getElementById("Summary");
    if (idModal){
      const modal = new ModalBootstrap(idModal);
      modal.show();
    }
  }

  const loadData = async (pageIndex = 0, pageCount = 10) => {
    const data = {...filters, paginate: pageIndex, numberrecords : pageCount}
    if(data.rol.length > 0 && (!isOnlyNumbers(data.rol) || data.rol.length > 15)){
      setMessageAlertError('El formato del Rol, es incorrecto!');
      setShowAlertError(true);
      return;
    }
    if(data.paciente.length > 0 && data.paciente.length > 50){
      setMessageAlertError('El limite de caracteres en Nombre paciente es 50!');
      setShowAlertError(true);
      return;
    }
    setState({...state, loading: true});
    const _response:any = await accountMedicalTeam(data);
    const { totalrecords, paginate, totalpaginate } = _response.data.pagination;
    if (_response?.status) {
      setState({
        data: _response.data.records,
        pageCount: parseInt(totalrecords),
        pageIndex: parseInt(paginate),
        pageSize: pageCount,
        pages: parseInt(totalpaginate),
        loading: false,
      });
    }
  }

  function removeProperties(array:any) {
    const propertiesToRemove = [
      'totalpaginate',
      'correlativo',
      'viewdetail',
      'totalrecords',
      'itemrecordgeneral',
      'Accion_Intervencion'
    ];
    return array.map((item:any) => {
      const newItem = { ...item };
      propertiesToRemove.forEach((prop:any) => {
        delete newItem[prop];
      });
      return newItem;
    });
  }
  function renamePropertiesInArray(array: any[]) {
    const propMap: { [key: string]: string } = {
      'NumeroRol': 'Nº Rol',
      'Paciente': 'Nombre Paciente',
      'Fecha_Ingreso': 'Fecha Hospitalizado',
      'Fecha_Alta': 'Fecha Alta',
      'Nombre': 'Prevision',
      'Numero_PAM': 'Nº PAM',
      'Profesional': 'Medico Tratante',
      'Parametro': 'Estado'
    };
  
    return array.map((item) => {
      const newItem: any = {};
      for (const originalProp in item) {
        if (propMap.hasOwnProperty(originalProp)) {
          newItem[propMap[originalProp]] = item[originalProp];
        } else {
          newItem[originalProp] = item[originalProp];
        }
      }
      return newItem;
    });
  }
  


  const downloadExcel =async () => {
    const url = process.env.REACT_APP_API_URL;
    const params= {...filters, paginate:1, numberrecords : 99999}
    Axios({
      url: `${url}/auth/equipomedico/search`,
      method: "GET",
      headers: {
        'Content-type': 'application/json',             
        Authorization: `Bearer ${auth?.access_token}`
      },
      params:params
    },).then((response) => {
      if (response.data.status) {
        //Creando Excel
        const workbook = XLSX.utils.book_new();
        let removeElements=removeProperties(response.data.data.records);
        let renameElements=renamePropertiesInArray(removeElements);
        //Cargando los elementos de un array
        const worksheet = XLSX.utils.json_to_sheet(renameElements);
        XLSX.utils.book_append_sheet(workbook, worksheet, 'EquipoMedico');        
        // Crear un Blob con el contenido del archivo Excel
        const excelBlob = new Blob([s2ab(XLSX.write(workbook, { bookType: 'xlsx', type: 'binary' }))], { type: 'application/octet-stream' });
        //Descargar Excel
        const link = document.createElement("a");
        link.href = URL.createObjectURL(excelBlob);
        link.setAttribute('download', `${Date.now()}.xlsx`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        alert('No se generó el archivo');
      }
    });
  }
  // Función para convertir cadena a ArrayBuffer
  function s2ab(s:any) {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) {
      view[i] = s.charCodeAt(i) & 0xFF;
    }
    return buf;
  }
  
  return (
    <>
      <Search filters={filters} onChange={onChange} loadData={loadData} downloadExcel={downloadExcel}/>
    
      <Table state={state} openModalDetail={openModalDetail} />

      <Modal id="Summary" size="modal-xl" title="Detalle Equipo Medico">
        <QueryDetail {...detail} />
      </Modal>

      <PaginationComponent totalPages={state.pages} activePage={state.pageIndex} searchData={loadData} loading={state.loading} />

      <AlertDialog
        message={messageAlertError}
        show={showAlertError}
        success={false}
        onConfirm={() => {
            setShowAlertError(false);
        }}
      />
    </>
  )
}

export default AccountMedicalTeam;